import { Dispatch, SetStateAction } from 'react';
import { GetShipsResponse } from '../../graphql/ships';

export type DeckPlanViewProps = {
  id: string;
  aftSideDescription?: string;
  midshipSideDescription?: string;
  forwardSideDescription?: string;
  deckMapKey?: string;
  deckMapKeyLegends?: LegendMultifieldItem[];
  deckMapKeyLegendsRest?: LegendMultifieldItemRest[];
  viewDeckMapKey?: string;
  shipCfData?: GetShipsResponse;
};

export type ShipProps = {
  side?: ShipSideEnum;
  imgDeckReference?: string;
  description?: string;
  onSelect?: ShipSideCallback;
  disabledSections: {
    aft: boolean;
    middle: boolean;
    forward: boolean;
  };
};

export type ShipSideProps = {
  title: ShipSideEnum;
  isSelected: boolean;
  onSelect: ShipSideCallback;
  disabledSection: boolean;
};

export type DeckMapKeyProps = {
  deckMapKey?: string;
  deckMapKeyLegends?: LegendMultifieldItem[];
  deckMapKeyLegendsRest?: LegendMultifieldItemRest[];
  viewDeckMapKey?: string;
};

export type DeckMapKeyItemProps = {
  item: string;
  icon?: string;
  color?: string;
  accessibilityLabel?: string;
};

export type ShipSideCallback = (side: ShipSideEnum) => void;

export type LegendMultifieldItem = {
  deckMapLegendLabel: string;
  deckMapLegendAccessibilityLabel: string;
  'jcr:primaryType': string;
};

export type LegendMultifieldItemRest = {
  deckMapLegendLabelRest: string;
  imgReference: string;
};

export type SvgViewerProps = {
  svgPath?: string;
  selectedSection: string;
  svgScale?: number;
  handleSelectedSection: Dispatch<SetStateAction<ShipSideEnum>> | ((side: ShipSideEnum) => void);
  isClicked?: boolean;
  setIsClicked: Dispatch<SetStateAction<boolean>>;
  disabledSections: { aft: boolean; middle: boolean; forward: boolean };
};

export enum ShipSideEnum {
  NONE = '',
  BACK = 'aft',
  MID = 'mid',
  FRONT = 'forward',
  MIDDLE = 'middle',
}

export enum ZoomEnum {
  ZOOMIN = 'ZOOMIN',
  ZOOMOUT = 'ZOOMOUT',
}
